import { useState } from 'react';
import { REACT_APP_DISCORD_BOT_ENDPOINT } from '../config/constants';

export default function PrivateGenerateBackupForm({ authToken }) {

  const [resourceList, setResourceList] = useState([]);
  const [loadingResource, setLoadingResource] = useState(true);
  const [selectedTipoRecurso, setSelectedTipoRecurso] = useState('');
  const [selectedHost, setSelectedHost] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [modifyDate, setModifyDate] = useState('');
  const [resourceClassList, setResourceClassList] = useState([]);
  const [loadingResourceClass, setLoadingResourceClass] = useState(true);
  const [selectedClass, setSelectedClass] = useState('');
  const tipoRecurso = [
    { "text": "EC2","value": "EC2","selected": false},
    { "text": "RDS","value": "RDS","selected": false},
  ];

const ec2Classesx86_64 = [
  { text: 't3a.nano (2 vCPU, 0.5 GiB RAM)', value: 't3a.nano' },
  { text: 't3a.micro (2 vCPU, 1 GiB RAM)', value: 't3a.micro' },
  { text: 't3a.small (2 vCPU, 2 GiB RAM)', value: 't3a.small' },
  { text: 't3a.medium (2 vCPU, 4 GiB RAM)', value: 't3a.medium' },
  { text: 't3a.large (2 vCPU, 8 GiB RAM)', value: 't3a.large' },
  { text: 'c5.large (2 vCPU, 4 GiB RAM)', value: 'c5.large' },
  { text: 'c5.xlarge (4 vCPU, 8 GiB RAM)', value: 'c5.xlarge' },
  { text: 'c5.2xlarge (8 vCPU, 16 GiB RAM)', value: 'c5.2xlarge' },
  { text: 'c5.4xlarge (16 vCPU, 32 GiB RAM)', value: 'c5.4xlarge' },
  { text: 'c5.9xlarge (18 vCPU, 36 GiB RAM)', value: 'c5.9xlarge' },
  { text: 'c5.12xlarge (24 vCPU, 48 GiB RAM)', value: 'c5.12xlarge' },
  { text: 'c5a.large (2 vCPU, 4 GiB RAM)', value: 'c5a.large' },
  { text: 'c5a.xlarge (4 vCPU, 8 GiB RAM)', value: 'c5a.xlarge' },
  { text: 'c5a.2xlarge (8 vCPU, 16 GiB RAM)', value: 'c5a.2xlarge' },
  { text: 'c5a.4xlarge (16 vCPU, 32 GiB RAM)', value: 'c5a.4xlarge' }
];
const ec2Classesarm64 = [
  { text: 't4g.nano (2 vCPU, 0.5 GiB RAM)', value: 't4g.nano' },
  { text: 't4g.micro (2 vCPU, 1 GiB RAM)', value: 't4g.micro' },
  { text: 't4g.small (2 vCPU, 2 GiB RAM)', value: 't4g.small' },
  { text: 't4g.medium (2 vCPU, 4 GiB RAM)', value: 't4g.medium' },
  { text: 't4g.large (2 vCPU, 8 GiB RAM)', value: 't4g.large' },
  { text: 'c6g.large (2 vCPU, 4 GiB RAM)', value: 'c6g.large' },
  { text: 'c6g.xlarge (4 vCPU, 8 GiB RAM)', value: 'c6g.xlarge' },
  { text: 'c6g.2xlarge (8 vCPU, 16 GiB RAM)', value: 'c6g.2xlarge' },
  { text: 'c6g.4xlarge (16 vCPU, 32 GiB RAM)', value: 'c6g.4xlarge' }
];

const rdsClasses = [
  { text: 'db.t3.micro (2 vCPU, 1 GiB RAM)', value: 'db.t3.micro' },
  { text: 'db.t3.small (2 vCPU, 2 GiB RAM)', value: 'db.t3.small' },
  { text: 'db.t3.medium (2 vCPU, 4 GiB RAM)', value: 'db.t3.medium' },
  { text: 'db.t3.large (2 vCPU, 8 GiB RAM)', value: 'db.t3.large' },
  { text: 'db.t4g.micro (2 vCPU, 1 GiB RAM)', value: 'db.t4g.micro' },
  { text: 'db.t4g.small (2 vCPU, 2 GiB RAM)', value: 'db.t4g.small' },
  { text: 'db.t4g.medium (2 vCPU, 4 GiB RAM)', value: 'db.t4g.medium' },
  { text: 'db.t4g.large (2 vCPU, 8 GiB RAM)', value: 'db.t4g.large' },
  { text: 'db.r6g.large (2 vCPU, 16 GiB RAM)', value: 'db.r6g.large' },
  { text: 'db.r6g.xlarge (4 vCPU, 32 GiB RAM)', value: 'db.r6g.xlarge' },
  { text: 'db.r6g.2xlarge (8 vCPU, 64 GiB RAM)', value: 'db.r6g.2xlarge' },
  { text: 'db.r6g.4xlarge (16 vCPU, 128 GiB RAM)', value: 'db.r6g.4xlarge' },
  { text: 'db.r6g.8xlarge (32 vCPU, 256 GiB RAM)', value: 'db.r6g.8xlarge' },
  { text: 'db.r6g.12xlarge (48 vCPU, 384 GiB RAM)', value: 'db.r6g.12xlarge' },
  { text: 'db.r6g.16xlarge (64 vCPU, 512 GiB RAM)', value: 'db.r6g.16xlarge' }
];

  const loadResourcesList = async (tipoRecurso) => {
    try {
      setLoadingResource(true);
      const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          command: 'opt',
          function: 'list-hosts-modify',
          tipoRecurso: tipoRecurso
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      setResourceList(data);
    } catch (error) {
      console.error('Erro ao carregar lista de Shared:', error);
      setResourceList([]);
    } finally {
      setLoadingResource(false);
    }
  };

  const handleTipoRecursoChange = (e) => {
    const tipo = e.target.value;
    setSelectedTipoRecurso(tipo);
    setSelectedHost('');
    setSelectedClass('');
    loadResourcesList(tipo);
    setLoadingResourceClass(true);
    if (tipo === 'EC2' || tipo === 'RDS') {
      setResourceClassList([]); // Limpa até selecionar o recurso
    } else {
      setResourceClassList([]);
    }
    setLoadingResourceClass(false);
  };

  const handleHostChange = (e) => {
    const value = e.target.value;
    setSelectedHost(value);
    setSelectedClass('');
    if (selectedTipoRecurso === 'EC2') {
      const parts = value.split('|');
      const arch = parts[2]; // x86_64 ou arm64
      setLoadingResourceClass(true);
      if (arch === 'x86_64') {
        setResourceClassList(ec2Classesx86_64);
      } else if (arch === 'arm64') {
        setResourceClassList(ec2Classesarm64);
      } else {
        setResourceClassList([]);
      }
      setLoadingResourceClass(false);
    }else if (selectedTipoRecurso === 'RDS') {
      setResourceClassList(rdsClasses);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Converter para formato DD/MM/YYYY HH:mm caso necessário
    let formattedModifyDate = modifyDate;
    if (modifyDate && modifyDate.includes('T')) {
      const [date, time] = modifyDate.split('T');
      const [year, month, day] = date.split('-');
      formattedModifyDate = `${day}/${month}/${year} ${time}`;
    }
    fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        command: 'submit',
        data: {
          form: 'modify_resource',
          tipoRecurso: selectedTipoRecurso,
          host: selectedHost,
          class: selectedClass,
          modifyDate: formattedModifyDate
        }
      }),
    })
      .then((res) => res.text())
      .then((msg) => {
        setSubmitted(true);
        setResponseMsg(msg);
      });
  };

  const [responseMsg, setResponseMsg] = useState('');

  if (submitted) {
    let content;
    try {
      const parsed = JSON.parse(responseMsg);
      content = (
        <div className="json-response-list">
          {Object.entries(parsed).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '0.5em' }}>
              <strong>{key}:</strong> <span>{String(value)}</span>
            </div>
          ))}
        </div>
      );
    } catch {
      content = <p>{responseMsg}</p>;
    }
    return (
      <div className="dynamic-form">
        <div className="success-message">
          {content}
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="dynamic-form">

      <div className="form-group">
        <label className="form-label">Tipo de Recurso</label>
        <select 
          value={selectedTipoRecurso} 
          onChange={handleTipoRecursoChange}
          className="form-select"
        >
          <option value="">Selecione o tipo de recurso</option>
          {tipoRecurso.map((tipoRecurso) => (
            <option key={tipoRecurso.value} value={tipoRecurso.value}>
              {tipoRecurso.text}
            </option>
          ))}
        </select>
      </div>

     
      {loadingResource && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando hosts do recurso...</p>
        </div>
      )}

      {resourceList.length > 0 && (
        <div className="form-group">
          <label className="form-label">Recurso</label>
          <select 
            value={selectedHost} 
            onChange={handleHostChange}
            className="form-select"
          >
            <option value="">Selecione um recurso</option>
            {resourceList.map((resource) => (
              <option key={resource.value} value={resource.value}>
                {resource.text}
              </option>
            ))}
          </select>
        </div>
      )}

      {loadingResourceClass && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando classes de recursos...</p>
        </div>
      )}

      {resourceClassList.length > 0 && (
        <div className="form-group">
          <label className="form-label">Classe do Recurso</label>
          <select 
            value={selectedClass} 
            onChange={(e) => setSelectedClass(e.target.value)}
            className="form-select"
          >
            <option value="">Selecione uma classe</option>
            {resourceClassList.map((resource) => (
              <option key={resource.value} value={resource.value}>
                {resource.text}
              </option>
            ))}
          </select>
        </div>
      )}

      
      <div className="form-group">
        <label className="form-label">Data e horário da alteração</label>
        <input
          type="datetime-local"
          value={modifyDate}
          onChange={(e) => setModifyDate(e.target.value)}
          className="form-input"
        />
      </div>

      <div className="form-actions">
        <button 
          type="submit" 
          disabled={!selectedTipoRecurso || !selectedHost || !selectedClass || !modifyDate}
          className="submit-button"
        >
          Continuar
        </button>
      </div>

      {submitted && (
        <div className="success-message">
          <span className="success-icon">✓</span>
          <p>Configuração enviada com sucesso!</p>
        </div>
      )}
    </form>
  );
} 